import analytics from 'yoda-core-components/lib/helpers/Analytics/Analytics';
import AnalyticsActionTypes from 'yoda-site-components/lib/actionTypes/AnalyticsActionTypes';
import { SET_PAGE_CACHE } from 'yoda-app-shell/lib/actionTypes/CacheActionTypes';
import * as IrisActionTypes from 'yoda-site-components/lib/actionTypes/IrisActionTypes';
import * as AdjustmentActionTypes from 'yoda-site-components/lib/actionTypes/AdjustmentActionTypes';
import * as CouponPageActionTypes from '../actionTypes/CouponPageActionTypes';
import CouponActionFilter from '../analytics/CouponActionFilter';

const couponActionFilter = new CouponActionFilter();

const CouponMiddleware = store => next => action => { // eslint-disable-line

    // Setting Coupon Page Cache in here on server side.
    if (__SERVER__) {
        switch (action.type) {
            case IrisActionTypes.IRIS_PAGE_SET_CACHE: {
                /* check the cacheControl and set the ttl value */
                const ttlValue = action.cacheControl ? action.cacheControl : 0;

                /**
                 * Dispatching Cache Action Here
                 */
                store.dispatch({
                    type: SET_PAGE_CACHE,
                    cache: { ttl: ttlValue },
                });
                break;
            }
            default:
                break;
        }
    }

    if (!__SERVER__) {
        let digitalData = null;
        let analyticsEventName = null;
        switch (action.type) {
            case CouponPageActionTypes.COUPON_PAGE_LOAD_READY:
            case AdjustmentActionTypes.ADJUSTMENTS_GET_SUCCESS_COUPONPAGE:
                digitalData = CouponActionFilter.getCouponpageDL(store);
                digitalData = couponActionFilter.updateCommonDigitalData(digitalData);
                analyticsEventName = 'digitalDataReady';
                break;
            case AnalyticsActionTypes.UPDATE_ANALYTICS_CLICK_EVENT:
                analyticsEventName = 'couponApplied';
                digitalData = CouponActionFilter.getCouponDL(store, analyticsEventName);
                break;
            case AnalyticsActionTypes.REMOVE_ANALYTICS_CLICK_EVENT:
                analyticsEventName = 'couponRemoved';
                digitalData = CouponActionFilter.getCouponDL(store, analyticsEventName);
                break;
            default:
                break;
        }
        /* istanbul ignore else */
        if (digitalData) {
            analytics.track(analyticsEventName, digitalData);
        }
    }
    return next(action);
};

export default CouponMiddleware;
